@if (!fields[field.html_name]) {
  @switch (field.data_type) {
    @case ('Option') {
      <i class="fa" [ngClass]="boolValueClass"></i>
    }
    @case ('Ganzzahl') {
      {{ $safeNavigationMigration(active?.value) | money:0 }}
    }
    @case ('Kommazahl') {
      {{ $safeNavigationMigration(active?.value) | money:4 }}
    }
    @default {
      {{ active?.value }}
    }
  }
}
